import { FormattedMessage } from 'react-intl';
import advancedMapLayersSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-advanced-map-layers.avif';
import customRoutesSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-custom-routes.avif';
import offlineMapsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-offline-maps.avif';
import routeAssistantSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-route-assistant.avif';
import trailConditionsSrc from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/images/feature-thumb-trail-conditions.avif';
import UpsellFeatureList from '@alltrails/upsell/components/UpsellSystem/UpsellFeatureList/UpsellFeatureList';
import memberDealsSrc from './feature-thumb-member-deals.avif';

const memberDealsRow = {
  body: <FormattedMessage defaultMessage="Exclusive savings on apparel, outdoor accommodations, flights, and more" />,
  src: memberDealsSrc,
  title: <FormattedMessage defaultMessage="Member Deals" />
};

const trailConditionsRow = {
  body: <FormattedMessage defaultMessage="Plan for trail-specific weather, snow depth, and more" />,
  src: trailConditionsSrc,
  title: <FormattedMessage defaultMessage="Trail Conditions" />
};

const rows = (isInUs: boolean) => [
  {
    body: <FormattedMessage defaultMessage="Plan backpacking trips effortlessly with our built-in assistant" />,
    src: routeAssistantSrc,
    title: <FormattedMessage defaultMessage="Route Assistant" />
  },
  {
    body: <FormattedMessage defaultMessage="Get detailed views of the land and terrain before you go" />,
    src: advancedMapLayersSrc,
    title: <FormattedMessage defaultMessage="Advanced Map Layers" />
  },
  {
    body: <FormattedMessage defaultMessage="Start from scratch or customize to create your perfect adventure in the app" />,
    src: customRoutesSrc,
    title: <FormattedMessage defaultMessage="Custom Routes" />
  },
  {
    body: <FormattedMessage defaultMessage="Download maps so you always know where you are, even without cell service" />,
    src: offlineMapsSrc,
    title: <FormattedMessage defaultMessage="Offline Maps" />
  },
  isInUs ? memberDealsRow : trailConditionsRow
];

type Props = {
  isInUs: boolean;
};

export default function PeakMembershipIncludes({ isInUs }: Props) {
  return <UpsellFeatureList label={<FormattedMessage defaultMessage="Peak membership includes" />} rows={rows(isInUs)} variant="compact" />;
}
